<script setup lang="ts" name="TimelineCharRow">
const { size = 'md' } = defineProps<{
  isHovered?: boolean;
  isActive?: boolean;
  isLastActive?: boolean;
  size?: 'md' | 'sm';
}>();

const SIZE_TO_CLASS = {
  md: 'h-[72px]',
  sm: 'h-[50px]',
};
</script>

<template>
  <div
    class="flex-center relative text-nowrap border-b border-charcoal-2"
    :class="[
      SIZE_TO_CLASS[size],
      {
        'bg-charcoal-1': isHovered,
        'border-t-2 bg-ocean-0': isActive,
        'border-t-ocean-4': isActive || isLastActive,
        'border-b-2 border-b-ocean-4': isLastActive,
      },
    ]"
  >
    <slot />
    <slot name="actions" />
  </div>
</template>
